import { Text } from '@lune-fe/lune-ui-lib'
import { Box } from '@mui/material'
import { FC } from 'react'

export enum MappingSteps {
    FILE_SETTINGS = 1,
    CLIENT_ACCOUNTS = 2,
    LOAD = 3,
    LEGS = 4,
    CALCULATION = 5,
}

const ProgressSteps: FC<{
    step: MappingSteps
    subLabel?: string
    showClientAccounts?: boolean
}> = ({ step, subLabel, showClientAccounts }) => {
    const steps: {
        label: string
        number: MappingSteps
    }[] = [
        {
            label: 'File settings',
            number: MappingSteps.FILE_SETTINGS,
        },
        {
            label: 'Client accounts',
            number: MappingSteps.CLIENT_ACCOUNTS,
        },
        {
            label: 'Shipping details',
            number: MappingSteps.LOAD,
        },
        {
            label: 'Leg details',
            number: MappingSteps.LEGS,
        },
        {
            label: 'Calculate emissions',
            number: MappingSteps.CALCULATION,
        },
    ].filter((e) => e.number !== MappingSteps.CLIENT_ACCOUNTS || showClientAccounts)

    return (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
                alignItems: 'baseline',
                justifyContent: 'space-between',
                mb: 7,
            }}
        >
            {steps.map((s) => (
                <>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            position: 'relative',
                            flexDirection: 'column',
                        }}
                    >
                        <Box
                            sx={{
                                width: '100%',
                                height: '48px',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Box
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    position: 'relative',
                                    ...(s.number !== MappingSteps.CALCULATION && {
                                        '&:after': {
                                            content: '""',
                                            width: '100%',
                                            height: '2px',
                                            backgroundColor:
                                                s.number < step ? 'Blue400' : `Grey400`,
                                            margin: 'auto',
                                            position: 'absolute',
                                            top: '7px',
                                            right: '-50%',
                                            zIndex: -1,
                                        },
                                    }),
                                }}
                            >
                                <Box
                                    sx={{
                                        color: 'white',
                                        backgroundColor: s.number <= step ? 'Blue400' : `Grey400`,
                                        width: '16px',
                                        height: '16px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '100%',
                                        position: 'relative',
                                    }}
                                />
                            </Box>
                        </Box>
                        <Text
                            variant={'body3'}
                            sx={{
                                color: s.number <= step ? 'Grey900' : `Grey400`,
                            }}
                        >
                            {s.label}
                        </Text>
                        {subLabel && s.number === MappingSteps.LEGS && (
                            <Text variant={'body3'} sx={{ color: `Grey600`, mt: 1 }}>
                                {subLabel}
                            </Text>
                        )}
                    </Box>
                </>
            ))}
        </Box>
    )
}

export default ProgressSteps
